import React from "react";
import "./../css/styles.css";

const Stepper = (props) => {

    const { steps, currentStep, setStep, isClickable } = props;

    return (
        <div className="d-flex justify-content-between align-items-start stepper-container">
            {steps.map((label, index) => (
                <div
                    key={index}
                    className={`d-flex flex-column align-items-center flex-grow-1 position-relative stepper-item cursor-pointer ${index < currentStep ? "step-completed" : ""
                        }`}
                    onClick={(e) => {
                        if (index < currentStep) {
                            if (currentStep > 0) {
                                setStep(index);
                            }
                        } else {
                            isClickable(e, index);
                        }
                    }}
                >
                    <div
                        className={`d-flex justify-content-center stepper-circle
              ${index < currentStep ? "stepper-completed" : ""}
              ${index === currentStep ? "stepper-current" : ""}
              ${index > currentStep ? "stepper-upcoming" : ""}
            `}
                    >
                        {index < currentStep ? (
                            <i className="bi bi-check-lg"></i>
                        ) : (
                            index + 1
                        )}
                    </div>
                    <div
                        className={`mt-1 stepper-label
              ${index === currentStep ? "fw-semibold" : "text-muted"}
            `}
                    >
                        {label}
                    </div>
                </div>
            ))}
        </div>
    );
}

export default Stepper;